webpackJsonp([520],{

/***/ 1127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": " | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 2081:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1127),
  /* template */
  __webpack_require__(2479),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/data/vux/home/websites/vux-repo/docs/node_modules/v-markdown-loader/_cache/next_en-278.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] next_en-278.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0fae77e3", Component.options)
  } else {
    hotAPI.reload("data-v-0fae77e3", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2479:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Alert")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Add prop:content")])]), _vm._v(" "), _c('h2', [_vm._v("Cell")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Support prop:is-loading")])]), _vm._v(" "), _c('h2', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] render picker on nextTick #1180")])]), _vm._v(" "), _c('h2', [_vm._v("Scroller")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] Fix issue when redirecting on scrolling #1187")]), _vm._v(" "), _c('li', [_vm._v("[fix] Fix resize listener not being destroyed #1183")])]), _vm._v(" "), _c('h2', [_vm._v("Swipeout")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] Fix cannot scroll when disabled")]), _vm._v(" "), _c('li', [_vm._v("[fix] Fix unable to trigger click event when disabled on android")])]), _vm._v(" "), _c('h2', [_vm._v("XIcon")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] Support all attributes #1147")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0fae77e3", module.exports)
  }
}

/***/ }),

/***/ 714:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2081);

/***/ })

});


// WEBPACK FOOTER //
// 520.11c96b42.js